import { render, staticRenderFns } from "./ChannelListItem.vue?vue&type=template&id=203ffea4&scoped=true"
import script from "./ChannelListItem.vue?vue&type=script&lang=js"
export * from "./ChannelListItem.vue?vue&type=script&lang=js"
import style0 from "./ChannelListItem.vue?vue&type=style&index=0&id=203ffea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203ffea4",
  null
  
)

export default component.exports